import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Resource} from '../../graphql/resources.datatypes';

interface ResourceData {
  resource: Resource
}

export const gqlResourceBank = `
  id
  resource_id
  capacity
  warning_count
  unit_price
  date
  remaining
`;

export const gqlResource = `
  id
  internal_name
  display_name
  t_and_c_url
  resource_type
  disabled
  has_price
  has_dates
  consumable
  available_from
  available_to
  allow_manual_overbooking
  show_on_invoice
  description
  locked
  comms_email_address
  max_additional_nights
  max_nights_before
  max_nights_after
  image_logo_url
  image_banner_url
  guest_capacity
  rain_date_note
  cancellation_policy
  terms_and_conditions
  contact_us_message
  invoice_document_id
  booking_tool_edit_cutoff
  netsuite_tour_type

  use_room_bank
  room_bank_resource_id
  allow_multiple

  payment_schedule {
    id
  }

  parent {
    id
    internal_name
    display_name
  }

  resources {
    id
    internal_name
    display_name
    t_and_c_url
    resource_type
    disabled
  }

  resource_banks(orderBy: [{column: "date", order: ASC}]) {
    ${gqlResourceBank}
  }

  tour_roles {
    id
    tour_resource_id
    tour_role
    age_lower_bound
    age_upper_bound
  }

  roomResources {
    internal_name
    guest_capacity

    resource_banks {
        capacity
        date
    }
  }

  options {
    id
    display_name
    internal_name
    disabled
    action_type
    action_value

    groupResources {
        id
        unitCost

        roomMemberOptions {
            id
            unit_cost
            unit_count
        }
        roomOptions {
            id
            unit_cost
            unit_count
        }
    }
  }

  documents {
    id
    title
  }

  credit_card_fee {
    id
    fee
  }
`;

export const GET_RESOURCE_QUERY = gql`
    query getResource($id: Int!){
        resource(id: $id){
          ${gqlResource}
        }
    }
`;

export const getResource = (resourceId: number | null) => {
  const id = resourceId? resourceId : -1;
  return useQuery<ResourceData>(
      GET_RESOURCE_QUERY,
      {
          variables: {id},
      }
  );
};

export default getResource;
